import { useQueryClient } from "@tanstack/react-query";
import ChipTabs from "../../components/ChipsTabs";
import PageContentWrapper from "../../components/wrappers/PageContentWrapper";
import useUser from "../../hooks/useUser";
import * as chips from "./component/chips/utils/Chips";
import { LOGGED_IN_USER } from "../../enums/QueryKeys";
import React from "react";
import { useProfileSettingsState } from "../../hooks/useProfileSettingsState";
import { useLocation } from "react-router-dom";

export default function ProfilePage() {
  const { booleans, isLoading } = useUser();
  const queryClient = useQueryClient();
  const location = useLocation();
  const { isForcedEdit, initialTab } = useProfileSettingsState();
  const navigationKey = location.state?.timestamp || "static";
  if (isLoading) return null;
  return (
    <PageContentWrapper>
      <ChipTabs
        key={`${navigationKey}}`}
        lsKey={"PROFILE_PAGE_LS_KEY"}
        icons={chips.icons}
        tabContent={chips.content}
        tabLabels={chips.titles}
        lastIndex={isForcedEdit ? initialTab : 0}
        tabTestIds={chips.testIds}
      />
    </PageContentWrapper>
  );
}
